
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 17.97 8\" id=\"arrow-up\" ><title>arrow-up</title><path d=\"M8.98 0L0 6.61 1.07 8l7.91-5.62L16.94 8l1.03-1.39L8.98 0z\" data-name=\"Layer 2\"/></symbol>";
module.exports = sprite.add(image, "arrow-up");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-up.svg
// module id = 646
// module chunks = 1474